import { combineReducers, createStore, applyMiddleware  } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import authentication from './authentication';
import modal from './modal';
import user from './user';
import emailSignup from './emailSignup';

const reducer = combineReducers({
	authentication,
	user,
	modal,
	emailSignup
});

/* eslint-disable no-underscore-dangle */
const store = createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(thunk, logger)
  )
);
/* eslint-enable */


export default store;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js